export default {
  FIREBASE_API_KEY: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyC4c9Q8xZLg5Chce3HMJGVZx71ZVMv18dM',
  FIREBASE_PROJECT_ID: process.env.REACT_APP_GCLOUD_PROJECT || 'back-office-236415',
  FIREBASE_MESSAGE_SENDER_ID: process.env.REACT_APP_FIREBASE_MESSAGE_SENDER_ID || '711981663529',
  FIREBASE_MESSAGE_CENTER_APP_ID: process.env.REACT_APP_FIREBASE_MESSAGE_CENTER_APP_ID || '1:711981663529:web:f131d120519c717deba338',
};
